import { render } from "./carousel-slide.vue?vue&type=template&id=524b3db3&scoped=true"
import script from "./carousel-slide.vue?vue&type=script&lang=js"
export * from "./carousel-slide.vue?vue&type=script&lang=js"

import "./carousel-slide.vue?vue&type=style&index=0&id=524b3db3&scoped=true&lang=css"

import exportComponent from "/home/runner/work/metal-client/metal-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-524b3db3"]])

export default __exports__